import React from 'react';
import PropTypes from 'prop-types';

const Forward = ({ className, color }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path
      d="M14.083 12.003h-.813c-.655 0-1.355 0-2.064-.002h-1.162c-.982.042-1.032.09-1.044 1v2c0 .552-.448 1-1 1s-1-.448-1-1v-2.013c.026-2.007.937-2.898 3-2.987h1.207l2.064.003h.82l-1.297-1.296c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0l3 3c.39.39.39 1.024 0 1.414l-3 3c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.024 0-1.414l1.29-1.29zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

Forward.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default Forward;
